import React, { FC } from "react";
import clsx from "clsx";

import s from "./RedesignButton.less";

export type RedesignButtonTheme =
  | "main"
  | "clear-accent"
  | "accent"
  | "empty-accent";

interface IProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  data?: unknown;
  isForm?: boolean;
  txtBtn: string;
  loading?: boolean;
  customClassName?: string;
  customIconClassName?: string;
  disabled?: boolean;
  theme?: RedesignButtonTheme;
  iconComponent?: React.ReactNode;
}

const RedesignButton: FC<React.PropsWithChildren<IProps>> = ({
  onClick,
  data,
  isForm = false,
  txtBtn,
  loading = false,
  customClassName = "",
  customIconClassName = "",
  children,
  disabled = false,
  theme = "main",
  iconComponent,
}) => {
  return (
    <button
      className={clsx(s.btn, s[`theme_${theme}`], customClassName)}
      type={isForm ? "submit" : "button"}
      onClick={onClick}
      disabled={disabled || loading}
      data-button_data={data}
    >
      {loading && <div className={s.loading} />}
      {(iconComponent || children || txtBtn) && (
        <div className={s.content}>
          {(iconComponent || children) && (
            <div
              className={clsx(s.icon, customIconClassName, {
                [s.loadingChildren]: loading,
              })}
            >
              {iconComponent || children}
            </div>
          )}
          {txtBtn && (
            <span
              className={clsx({
                [s.loadingChildren]: loading,
              })}
            >
              {txtBtn}
            </span>
          )}
        </div>
      )}
    </button>
  );
};

export default RedesignButton;
